export default "__VITE_ASSET__1d21fad1__"